export default __webpack_public_path__ + "static/media/like-star-grey.8b14ffca.svg";